/* eslint-disable angular/controller-as */

angular.
module("dx.webapp.library").
controller("DxGradingMatrixLibraryController", function GradingMatrixController(
	$filter,
	$scope,

	DX_URLS,
	dxRubricsRepository,

	localStorageService
) {
	"use strict";

	$scope.Urls = DX_URLS;
	$scope.dxRubricsRepository = dxRubricsRepository;
	dxRubricsRepository.loadDefault();

	$scope.sortingOptions = {
		title: {
			order: "title",
			i18n: "Title",
		},
		description: {
			order: "description",
			i18n: "Description",
		},
		modified: {
			order: "-updated",
			i18n: "LastModified",
		},
		created: {
			order: "-created",
			i18n: "LastCreated",
		},
	};

	var localStorageSortingKey = "library.gradingMatrix.sort";

	$scope.searchQuery = "";
	$scope.sortOrder = localStorageService.get(localStorageSortingKey) || $scope.sortingOptions.title;

	$scope.searchFilter = function searchFilter(gradingMatrix) {
		if (!$scope.searchQuery) {
			return true;
		}

		var formattedGradingMatrixCreated = $filter("date")(gradingMatrix.created, "yyyy-MM-dd");
		var searchString = [gradingMatrix.title, gradingMatrix.description, formattedGradingMatrixCreated].join(" # ");

		return searchString.toLowerCase().indexOf($scope.searchQuery.toLowerCase()) !== -1;
	};

	$scope.setSortOrder = function setSortOrder(sortingOption) {
		$scope.sortOrder = sortingOption;
		return localStorageService.set(localStorageSortingKey, sortingOption);
	};
});
